import React from "react";
import styled from "@emotion/styled";
import { useDispatch, useSelector } from "react-redux";
import { ERROR_EMUNS, LOADING_EMUNS } from "../constant";
import * as a from "../action";
import { SecondaryButton } from "../../Button";

const Button = styled(SecondaryButton)`
  width: 250px;
`;

const UploadSpreadSheetClearErrors = () => {
  const dispatch = useDispatch();
  const loadingState = useSelector((state) => state.ssUploader.loading.state);

  const removeAllErrorCards = () => {
    dispatch(a.doResetCards());
    dispatch(a.setLoadingState(LOADING_EMUNS.DEFAULT));
    dispatch(a.setErrorType(ERROR_EMUNS.DEFAULT));
  };

  if (loadingState === LOADING_EMUNS.ERROR) {
    return (
      <Button
        onClick={(e) => {
          e.preventDefault();
          removeAllErrorCards();
        }}
      >
        Clear Errors
      </Button>
    );
  }

  return null;
};

export { UploadSpreadSheetClearErrors };
